import Discrepancies from './Discrepancies';

export default Discrepancies; 